// T-Shirt Product Images Configuration using Backend Proxy
// Using Spreadshirt images for display (all 4 views), Printful for fulfillment
// Build timestamp: 2026-05-13 - Forces fresh deployment build

// Use relative URL for API calls - works on any domain
// REACT_APP_BACKEND_URL is only needed for preview/dev environments
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const WIDTH = 600;
const HEIGHT = 800;

// Color configuration - appearanceId for Spreadshirt images, printfulVariantId for orders
export const TSHIRT_COLORS = [
  { id: 'white', name: 'White', hex: '#FFFFFF', appearanceId: 1, printfulVariantId: 4012 },
  { id: 'black', name: 'Black', hex: '#222222', appearanceId: 2, printfulVariantId: 4017 },
  { id: 'navy', name: 'Navy', hex: '#1F2937', appearanceId: 4, printfulVariantId: 4112 },
  { id: 'red', name: 'Red', hex: '#DC2626', appearanceId: 5, printfulVariantId: 4142 },
  { id: 'gold', name: 'Gold', hex: '#F59E0B', appearanceId: 7, printfulVariantId: 4082 },
  { id: 'turquoise', name: 'True Royal', hex: '#0EA5E9', appearanceId: 17, printfulVariantId: 4172 },
  { id: 'green', name: 'Kelly Green', hex: '#16A34A', appearanceId: 92, printfulVariantId: 4087 },
];

export const VIEWS = ['front', 'back', 'left', 'right'];

const VIEW_IDS = {
  front: 1,
  back: 2,
  right: 3,
  left: 4,
};

// Generate image URL using backend proxy (Spreadshirt)
const generateImageUrl = (appearanceId, viewId) => {
  return `${BACKEND_URL}/api/product-image/${appearanceId}/${viewId}?width=${WIDTH}&height=${HEIGHT}`;
};

// Build the complete product images object
export const getProductImages = () => {
  const images = {};
  
  TSHIRT_COLORS.forEach(color => {
    images[color.id] = {
      front: generateImageUrl(color.appearanceId, VIEW_IDS.front),
      back: generateImageUrl(color.appearanceId, VIEW_IDS.back),
      left: generateImageUrl(color.appearanceId, VIEW_IDS.left),
      right: generateImageUrl(color.appearanceId, VIEW_IDS.right),
    };
  });
  
  return images;
};

export const PRODUCT_IMAGES = getProductImages();

// Get image URL for specific color and view
export const getTShirtImage = (colorId, view) => {
  const colorImages = PRODUCT_IMAGES[colorId];
  if (colorImages && colorImages[view]) {
    return colorImages[view];
  }
  return PRODUCT_IMAGES.white?.front || '';
};

// Preload images for smooth transitions
export const preloadImages = (colorId) => {
  const images = PRODUCT_IMAGES[colorId];
  if (images) {
    Object.values(images).forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }
};

export const preloadAllImages = () => {
  Object.keys(PRODUCT_IMAGES).forEach(colorId => {
    preloadImages(colorId);
  });
};

export default {
  TSHIRT_COLORS,
  VIEWS,
  PRODUCT_IMAGES,
  getTShirtImage,
  preloadImages,
  preloadAllImages,
};
